import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useBasePath } from './use-base-path';
import { canGoBackInApp } from './drawer-nav';

/**
 * The app's single back action, shared by the header back button (mobile) and the in-content back
 * button (desktop). Pops in-app history when there is a prior entry to return to; on a direct
 * deep-link / load into a drill-in, `router.back()` would leave the site, so it falls back to home.
 */
export function useAppBack(): () => void {
  const router = useRouter();
  const basePath = useBasePath();
  return useCallback(() => {
    if (canGoBackInApp()) router.back();
    else void router.push('/', `${basePath}/`);
  }, [router, basePath]);
}
